import { render, staticRenderFns } from "./singleMessageStatistics.vue?vue&type=template&id=3a2789c7&scoped=true&"
import script from "./singleMessageStatistics.vue?vue&type=script&lang=js&"
export * from "./singleMessageStatistics.vue?vue&type=script&lang=js&"
import style0 from "./singleMessageStatistics.vue?vue&type=style&index=0&id=3a2789c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2789c7",
  null
  
)

component.options.__file = "singleMessageStatistics.vue"
export default component.exports